import { Box, ButtonGroup, Button } from '@mui/joy';
import { useSearchParamState } from 'helperFunctions/react';
import MarketingItemsSettings from './marketingItems';
import MarketingSettings from './marketingSettings';

const tabList = [
    ['Marketing Items', MarketingItemsSettings],
    ['Marketing Packages', MarketingSettings],
] as const; // Use `as const` for a fixed type

type TabName = (typeof tabList)[number][0]; // Infer the type of the first element in each tuple

export default () => {
    const [activeTab, setActiveTab] = useSearchParamState<TabName>('subTab', 'Marketing Items');

    return (
        <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
            {/* Button Group to replace Tabs */}
            <ButtonGroup variant="outlined" sx={{ mb: 2 }}>
                {tabList.map(([label]) => (
                    <Button
                        key={label}
                        onClick={() => setActiveTab(label)}
                        variant={activeTab === label ? 'soft' : 'outlined'} // Highlight active button
                    >
                        {label}
                    </Button>
                ))}
            </ButtonGroup>

            {/* Render the active component */}
            <Box sx={{ py: 2 }}>
                {tabList.map(([name, Component]) => (
                    <Box
                        key={name}
                        sx={{
                            display: activeTab === name ? undefined : 'none',
                        }}
                    >
                        <Component />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
